export default __webpack_public_path__ + "static/sharing-image-db5dc5b9424e9194bebb470cf9c6e978.jpg";